import { BaseServiceRestoreStateGenerator } from './baseServiceRestoreStateGenerator';
import { CalculationResultProcessor } from './processors/calculationResultProcessor';
import { FilterResultProcessor } from './processors/filterResultProcessor';
import { FilterWithAppliedFiltersProcessor } from './processors/filterWithAppliedFiltersProcessor';
import { FilterWithPriceProcessor } from './processors/filterWithPriceProcessor';
import { GlobalOptionsProcessor } from './processors/globalOptionsProcessor';
import { GlobalPropertiesProcessor } from './processors/globalPropertiesProcessor';
import { InitialCalculationResultProcessor } from './processors/initialCalculationResultProcessor';
import { InitialFilterProcessor } from './processors/initialFilterProcessor';
import { InitialGlobalFieldsProcessor } from './processors/initialGlobalFieldsProcessor';
import { InitialVariantFieldsProcessor } from './processors/initialVariantFieldsProcessor';
import { ServiceCacheProcessor } from './processors/serviceCacheProcessor';
import { ServicePropertyCacheOptionsProcessor } from './processors/servicePropertyCacheOptionsProcessor';
import { ServicePropertyCacheProcessor } from './processors/servicePropertyCacheProcessor';
import { ServicesPathProcessor } from './processors/servicesPathProcessor';
import { SetUpGlobalFieldsProcessor } from './processors/setUpGlobalFieldsProcessor';
import { SetUpVariantFieldsProcessor } from './processors/setUpVariantFieldsProcessor';
import { StopBeforeServiceCalculationProcessor } from './processors/stopBeforeServiceCalculationProcessor';
import { TemplateStoreProcessor } from './processors/templateStoreProcessor';
import { ValidationGlobalFieldProcessor } from './processors/validationGlobalFieldProcessor';
import { VariantFieldsProcessor } from './processors/variantFieldsProcessor';
import { VariantOptionsProcessor } from './processors/variantOptionsProcessor';
import { VariantPropertiesProcessor } from './processors/variantPropertiesProcessor';
import { VariantPropertyValuesProcessor } from './processors/variantPropertyValuesProcessor';
import { VariantSelectedServicesProcessor } from './processors/variantSelectedServicesProcessor';
import { VariantServicesProcessor } from './processors/variantServicesProcessor';
import { VariantsProcessor } from './processors/variantsProcessor';

// Фабрика сервиса
const serviceRestoreStateGenerator = () =>
  new BaseServiceRestoreStateGenerator([
    new ServicesPathProcessor(),
    new InitialGlobalFieldsProcessor(),
    new SetUpGlobalFieldsProcessor(),
    new GlobalOptionsProcessor(),
    new ValidationGlobalFieldProcessor(),
    new GlobalPropertiesProcessor(),
    new StopBeforeServiceCalculationProcessor(),
    new VariantsProcessor(),
    new VariantServicesProcessor(),
    new VariantSelectedServicesProcessor(),
    new VariantFieldsProcessor(),
    new InitialVariantFieldsProcessor(),
    new SetUpVariantFieldsProcessor(),
    new VariantOptionsProcessor(),
    new VariantPropertiesProcessor(),
    new VariantPropertyValuesProcessor(),
    new TemplateStoreProcessor(),
    new InitialCalculationResultProcessor(),
    new CalculationResultProcessor(),
    new ServiceCacheProcessor(),
    new ServicePropertyCacheProcessor(),
    new ServicePropertyCacheOptionsProcessor(),
    new InitialFilterProcessor(),
    new FilterWithPriceProcessor(),
    new FilterWithAppliedFiltersProcessor(),
    new FilterResultProcessor(),
  ]);

export default serviceRestoreStateGenerator;
